import {
	createStore,
	createActionsHook,
	createStateHook,
	defaultRegistry,
} from 'react-sweet-state';

export enum ClientNetworkStatus {
	IP_BLOCKED = 'IP_BLOCKED',
	OFFLINE = 'OFFLINE',
	ONLINE = 'ONLINE',
	RATE_LIMITED = 'RATE_LIMITED',
	SESSION_EXPIRED = 'SESSION_EXPIRED',
}

type ClientNetworkType = ClientNetworkStatus | undefined;

const useNetworkStatusListenerCacheStore = createStore({
	name: 'useNetworkStatusListenerCache',
	initialState: {
		network: undefined as ClientNetworkType,
	},
	actions: {
		setNetworkStatus:
			(status: ClientNetworkType) =>
			({ setState }) => {
				setState({ network: status });
			},
		getNetworkStatus:
			() =>
			({ getState }) => {
				return getState().network;
			},
	},
});

export const useNetworkStatusListenerCache = createStateHook(useNetworkStatusListenerCacheStore, {
	selector: (state) => state.network,
});

export const useNetworkStatusListenerCacheStoreActions = createActionsHook(
	useNetworkStatusListenerCacheStore,
);

// // Create and export container for non-React usage
export const NetworkStatusContainer = defaultRegistry.getStore(useNetworkStatusListenerCacheStore);

// Helper functions for non-React usage
export const getNetworkStatus = () => {
	return NetworkStatusContainer.storeState.getState().network;
};

export const setNetworkStatus = (status: ClientNetworkType) => {
	return NetworkStatusContainer.actions.setNetworkStatus(status);
};
